import { Link } from "react-router-dom";
import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";

export default function ComicGrid() {
  const latestComics = comics.slice(0, 8);

  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1.5">热门漫画持续连载中，追更不停歇</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {latestComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              coverImage={comic.coverImage}
              rating={comic.rating}
              status={comic.status}
              chapters={comic.chapters}
              variant="default"
            />
          ))}
        </div>
      </div>
    </section>
  );
}